import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: benjocaz45
 * id DA9F3CE2-81E2-4113-B8E7-64CE579D0890
 * name post-lamp
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/post-lamp.svg
 * tags
 * - Home Automation 
 */
export const PostLampIcon = createSvgIcon(<><path d="M14 3L13 1H11L10 3L5 6H7L8 14L10 16L10.5 17H9V23H15V17H13.5L14 16L16 14L17 6H19L14 3M14.16 13H9.84L9 6H15L14.16 13Z" /></>, 'PostLampIcon');
export default PostLampIcon